export default __webpack_public_path__ + "static/zm-1fda09ef18791acb54ba026995339ac1.svg";